import React from 'react'
import LeftArrow from '../data/leftArrow.png'
import RightArrow from '../data/rightArrow.png'
import BackWard from '../data/backWard.png'
import Forward from '../data/forward.png'

const Pagination = ({ currentPage, totalPages, totalItems, onPageChange, pageHop = 10 }) => {
  const numbers = Array.from({ length: totalPages }, (_, i) => i + 1)

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 10px 10px 27px',
        border: '1px solid #e0e0e0',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13 }}>
        <div onClick={() => { if (currentPage > 1) onPageChange(1) }} style={{ marginRight: 21 }}>
          <img src={BackWard} style={{ width: 11, height: 11, opacity: currentPage > 1 ? 1 : 0.5, cursor: 'pointer' }} alt='first' />
        </div>
        <div onClick={() => { if (currentPage > 1) onPageChange(currentPage - 1) }} style={{ marginRight: 14 }}>
          <img src={LeftArrow} style={{ width: 9, height: 9, opacity: currentPage > 1 ? 1 : 0.5, cursor: 'pointer' }} alt='prev' />
        </div>
        {currentPage > 2 && (
          <div
            className='pagingNumber'
            onClick={() => onPageChange(Math.max(1, currentPage - pageHop))}
            style={{ fontWeight: 'bold' }}
          >
            ...
          </div>
        )}
        {numbers.map((number) =>
          (number === currentPage ||
            number === currentPage - 1 ||
            number === currentPage + 1 ||
            (currentPage === 1 && number === 3) ||
            (currentPage === totalPages && number === totalPages - 2)) ? (
            <div
              key={number}
              className={currentPage === number ? 'pagingNumberSelected' : 'pagingNumber'}
              onClick={() => onPageChange(number)}
            >
              {number}
            </div>
          ) : null
        )}
        {currentPage + 1 < totalPages && (
          <div
            className='pagingNumber'
            onClick={() => onPageChange(Math.min(totalPages, currentPage + pageHop))}
            style={{ fontWeight: 'bold' }}
          >
            ...
          </div>
        )}
        <div onClick={() => { if (totalPages !== currentPage) onPageChange(currentPage + 1) }} style={{ marginLeft: 13.5 }}>
          <img src={RightArrow} style={{ width: 10, height: 10, opacity: totalPages !== currentPage ? 1 : 0.5, cursor: 'pointer' }} alt='next' />
        </div>
        <div onClick={() => { if (totalPages !== currentPage) onPageChange(totalPages) }} style={{ marginLeft: 19 }}>
          <img src={Forward} style={{ width: 12, height: 12, opacity: totalPages !== currentPage ? 1 : 0.5, cursor: 'pointer' }} alt='last' />
        </div>
      </div>
      <span style={{ margin: '0 6.5px', fontSize: 13 }}>
        {`${currentPage} of ${totalPages} Pages (${totalItems} items)`}
      </span>
    </div>
  )
}

export default Pagination
